module.exports = "/shifts/components/calendarHeader/printWeekHeader-ab81a8.html";